export const currencies = [
  { value: 'USD', label: 'USD – US Dollar' },
  { value: 'EUR', label: 'EUR – Euro' },
  { value: 'GBP', label: 'GBP – British Pound' },
  { value: 'JPY', label: 'JPY – Japanese Yen' },
  { value: 'CNY', label: 'CNY – Chinese Yuan' },
  { value: 'HKD', label: 'HKD – Hong Kong Dollar' },
  { value: 'TWD', label: 'TWD – New Taiwan Dollar' },
  { value: 'SGD', label: 'SGD – Singapore Dollar' },
  { value: 'AUD', label: 'AUD – Australian Dollar' },
  { value: 'CAD', label: 'CAD – Canadian Dollar' },
  { value: 'CHF', label: 'CHF – Swiss Franc' },
  { value: 'INR', label: 'INR – Indian Rupee' },
  { value: 'KRW', label: 'KRW – South Korean Won' },
  { value: 'BRL', label: 'BRL – Brazilian Real' },
  { value: 'other', label: 'Other' },
] as const;

export type CurrencyValue = (typeof currencies)[number]['value'];
